import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/gaupalika/GaupalikaClientWrapper.tsx");
